// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopProgressBar_wrapper__SBCH5","bar":"TopProgressBar_bar__zSgjn"};